__turbopack_context__.v({
  "ctaButton": "dualOfferComparisonTable-module-scss-module__tUOHGW__ctaButton",
  "dualOfferComparisonTableWrapper": "dualOfferComparisonTable-module-scss-module__tUOHGW__dualOfferComparisonTableWrapper",
  "dualOfferTable": "dualOfferComparisonTable-module-scss-module__tUOHGW__dualOfferTable",
  "headerGrid": "dualOfferComparisonTable-module-scss-module__tUOHGW__headerGrid",
  "heading": "dualOfferComparisonTable-module-scss-module__tUOHGW__heading",
  "includedIcon": "dualOfferComparisonTable-module-scss-module__tUOHGW__includedIcon",
  "offerRadio": "dualOfferComparisonTable-module-scss-module__tUOHGW__offerRadio",
  "offerSelector": "dualOfferComparisonTable-module-scss-module__tUOHGW__offerSelector",
  "offerSelectorNotPromoted": "dualOfferComparisonTable-module-scss-module__tUOHGW__offerSelectorNotPromoted",
  "optionalAddOn": "dualOfferComparisonTable-module-scss-module__tUOHGW__optionalAddOn",
  "priceText": "dualOfferComparisonTable-module-scss-module__tUOHGW__priceText",
  "priceTextFooter": "dualOfferComparisonTable-module-scss-module__tUOHGW__priceTextFooter",
  "pricingRow": "dualOfferComparisonTable-module-scss-module__tUOHGW__pricingRow",
  "rowHeaderDescription": "dualOfferComparisonTable-module-scss-module__tUOHGW__rowHeaderDescription",
  "rowHeaderTitle": "dualOfferComparisonTable-module-scss-module__tUOHGW__rowHeaderTitle",
  "selectorEyebrow": "dualOfferComparisonTable-module-scss-module__tUOHGW__selectorEyebrow",
  "selectorPlanName": "dualOfferComparisonTable-module-scss-module__tUOHGW__selectorPlanName",
  "subhead": "dualOfferComparisonTable-module-scss-module__tUOHGW__subhead",
  "textLinkBelowCta": "dualOfferComparisonTable-module-scss-module__tUOHGW__textLinkBelowCta",
  "ymmBanner": "dualOfferComparisonTable-module-scss-module__tUOHGW__ymmBanner",
  "ymmBannerFilled": "dualOfferComparisonTable-module-scss-module__tUOHGW__ymmBannerFilled",
  "youGetPlanText": "dualOfferComparisonTable-module-scss-module__tUOHGW__youGetPlanText",
});
